import React from "react";
import { HeaderContainer } from "../styled/common";
import { IoArrowBackSharp } from "react-icons/io5";
import { HiOutlineHome } from "react-icons/hi2";
import { useNavigate } from "react-router";

const Header = ({ title, handleBackButton }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/self-service");
  };

  return (
    <HeaderContainer>
      <div className="headerSide left">
        <button
          type="button"
          className="iconBtn backBtn"
          onClick={() => handleBackButton?.()}
          aria-label="이전으로"
        >
          <IoArrowBackSharp />
          <span>이전</span>
        </button>
      </div>

      <div className="headerCenter">
        <h2>{title}</h2>
      </div>

      <div className="headerSide right">
        <button
          type="button"
          className="homeBtn"
          onClick={handleGoHome}
          aria-label="처음으로"
        >
          <HiOutlineHome />
          <span>처음으로</span>
        </button>
      </div>
    </HeaderContainer>
  );
};

export default Header;